import { set, get, getOr, reject } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createFetchOneHandler,
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  fetchInventoryLocation,
  fetchInventoryLocations,
  createInventoryLocation,
  updateInventoryLocation,
  deleteInventoryLocation
} from '../../sagas/routines';
import {
  clearInventoryLocations,
  updateInventoryLocationZones,
  removeZoneFromInventoryLocation,
  inventoryLocationsOnChangePage,
  inventoryLocationsOnChangeOrder
} from '../../actions/location';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearLocationsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const updateLocationZonesHandler = action => ({
  [action.toString()]: (state, { payload: newZones }) => {
    const id = get(`0.inventoryLocationId`, newZones);
    const existingZones = getOr([], `all.${id}.zones`, state);
    return set(`all.${id}.zones`, [...existingZones, ...newZones], state);
  }
});

const updateInventoryLocationCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: newZones }) =>
    set('pagination.currentPage', newZones, state)
});

const updateInventoryLocationsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const removeZoneFromLocationHandler = action => ({
  [action.toString()]: (state, { payload: { id, zoneId } }) => {
    const zones = get(`all.${id}.zones`, state);
    const newZones = reject({ id: zoneId }, zones);
    return set(`all.${id}.zones`, newZones, state);
  }
});

export default createReducer(initialState, {
  ...createFetchOneHandler(fetchInventoryLocation),
  ...createFetchManyHandler(fetchInventoryLocations),
  ...createSaveHandler(createInventoryLocation),
  ...createUpdateHandler(updateInventoryLocation),
  ...createDeleteHandler(deleteInventoryLocation),
  ...clearLocationsHandler(clearInventoryLocations),
  ...updateLocationZonesHandler(updateInventoryLocationZones),
  ...removeZoneFromLocationHandler(removeZoneFromInventoryLocation),
  ...updateInventoryLocationCurrentPageHandler(inventoryLocationsOnChangePage),
  ...updateInventoryLocationsOnChangeOrderHandler(
    inventoryLocationsOnChangeOrder
  )
});
